export const coupon = [
  {
    path: '/digitalMarketing/coupon/list',
    name: 'couponList',
    component: () => import('views/digitalMarketing/coupon/list'),
    meta: {
      title: '优惠券'
    }
  },
  {
    path: '/digitalMarketing/coupon/mySendCoupons',
    name: 'mySendCoupons',
    component: () => import('views/digitalMarketing/coupon/mySendCoupons'),
    meta: {
      title: '我发的券'
    }
  },
  {
    path: '/digitalMarketing/coupon/couponDetail',
    name: 'couponDetail',
    component: () => import('views/digitalMarketing/coupon/couponDetail'),
    meta: {
      title: '优惠券详情'
    }
  },
  {
    path: '/digitalMarketing/coupon/addCoupon',
    name: 'addCoupon',
    component: () => import('views/digitalMarketing/coupon/addCoupon'),
    meta: {
      title: '创建优惠券'
    }
  },
  {
    path: '/digitalMarketing/coupon/couponChooseStore',
    name: 'couponChooseStore',
    component: () => import('views/digitalMarketing/coupon/chooseStore'),
    meta: {
      title: '选择门店'
    }
  },
  {
    path: '/digitalMarketing/coupon/chooseSpreadWay',
    name: 'chooseSpreadWay',
    component: () => import('views/digitalMarketing/coupon/chooseSpreadWay'),
    meta: {
      title: '选择推广方式'
    }
  },
  {
    path: '/digitalMarketing/coupon/couponAddResult',
    name: 'couponAddResult',
    component: () => import('views/digitalMarketing/coupon/couponAddResult'),
    meta: {
      title: '优惠券创建结果'
    }
  }
]
